import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
    Button,
    CircularProgress,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Menu,
    MenuItem,
    styled,
    Tab,
    Tabs,
    Tooltip,
} from "@mui/material";
import { compact, filter, get, head, includes, uniq } from "lodash/";
import React, { useEffect, useState } from "react";
import CustomDataGridFilterToolbar from "../../../common/js/components/CustomDataGridFilterToolbar";
import KMSwitch from "../../../common/js/components/KMSwitch";
import { ExportIcon, List, Map } from "../../../common/js/icons";
import ReportTitleModal from "../listing/ReportTitleModal";
import NameSearchModal from "../search/NameSearchModal";
import SavedSearchesModal from "../search/SavedSearchesModal";
import { getFromAttributeValues } from "../utils/operations";
import "./Comp.css";
import CompFilters from "./CompFilters";
import CompsWithMap from "./CompsWithMap";
import CompsWithoutMap from "./CompsWithoutMap";
import ConfidentialCompModal from "./ConfidentialCompModal";
import CreateCompModal from "./CreateCompModal";
import GenerateImageEditorModalContainer from "./GenerateImageEditorModalContainer";
import MyCompsDataGrid from "./MyCompsDataGrid";
import OutsideCompModal from "./OutsideCompModal";

const StyledPageDiv = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    boxSizing: "border-box",
    alignItems: "center",
    margin: "20px -8px 20px -8px",
});

const StyledCompTable = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    boxSizing: "border-box",
    alignItems: "center",
    margin: "-8px",
    maxWidth: "100%",
});

const StyledTab = styled(Tab)({
    marginRight: "20px",
});

const StyledLoadingProgress = styled(CircularProgress)({
    marginRight: "5px",
    color: "grey",
});

const ReviewComps = (props) => {
    const {
        clearFilters,
        errors,
        filterQuery,
        handleDealTypeRadioClick,
        handleSearchSubmit,
        handleSelectAllPropertyType,
        handleSizeRadioClick,
        handleSort,
        handleStatusRadioClick,
        comps,
        compTab,
        propertySearchFilters,
        propertyTypeExpansionPanels,
        role,
        user,
        userProfile,
        searchCriteria,
        searchProperty,
        switchTab,
        togglePropertyTypeExpansionPanel,
        updateFilter,
        addAppraisalComp,
        toggleMarketFilterExpansionPanel,
        marketFilterExpansionPanels,
        handleSelectMarket,
        handleSelectSubmarket,
        handleSelectMicromarket,
        searchResponse,
        generateCompReport,
        elementsSaving,
        dataExport,
        handleDataExport,
        loadedSearchCrumbs,
        handleDeleteCrumb,
        loadingSearch,
        toggleLoadingSearch,
        mapCrumbCleared,
        handleSearchCleared,
        searchCleared,
        searchPolygon,
        updateSearchPolygon,
        searchRun,
        viewSavedModal,
        nameSaveModal,
        addSelectedToGroup,
        deleteSelectedFromGroup,
        clearCurrentGroup,
        selectedCompsGroup,
        compCurrentGroup,
        handleSearchCompsSubmit,
        modalContent,
        toggleModal,
        timeOnMarketInput,
        setDealParty,
        handleCloseModal,
        setMarketingFlyerPhoto,
        resetPhoto,
        handleSelectAll,
        handleSelectAllGroup,
        handleSelectAllBrokerComps,
        toggleModalAndGetPhotos,
        toggleReportTitleModal,
        brokerComps,
        selectedComps,
        setCompsFilter,
        setCompsPage,
        getComps,
        confidentialFlagForBrokerComps,
        selectedBrokerCompsForMyComps,
        resetSelectedBrokerComps,
        showSelectedItemsOnly,
        toggleShowSelectedItemsOnly,
    } = props;

    const [selectAll, setSelectAll] = useState(true);
    const [selectAllGroup, setSelectAllGroup] = useState(true);
    const [selectAllBrokerComps, setSelectAllBrokerComps] = useState(true);
    const [reportDropdown, setReportDropdown] = useState(false);
    const [exportDropdown, setExportDropdown] = useState(null);
    const [metroReport, setMetroReport] = useState(false);
    const [reportStyle, setReportStyle] = useState(null);
    const [mapDisplay, setMapDisplay] = useState(true);
    const [confidentialCompModalOpen, setConfidentialCompModalOpen] = useState(false);
    const [reportType, setReportType] = useState(null);
    const [closeDealDialogOpen, setCloseDealDialogOpen] = useState(false);
    const [clientSideSortModel, setClientSideSortModel] = useState([]);

    const toggleSelectAll = () => {
        const checked = selectAll;
        handleSelectAll(!checked);
        setSelectAll(!checked);
    };

    const toggleSelectAllGroup = () => {
        const checked = selectAllGroup;
        handleSelectAllGroup(!checked);
        setSelectAllGroup(!checked);
    };

    const toggleSelectAllBrokerComps = () => {
        const checked = selectAllBrokerComps;
        handleSelectAllBrokerComps(!checked);
        setSelectAllBrokerComps(!checked);
    };

    const toggleMap = (mapView) => {
        setMapDisplay(mapView);
    };

    const handleClickOpen = (reportStyle) => {
        setReportDropdown(null);
        if (reportStyle === "Metro") {
            setMetroReport(true);
        } else {
            setMetroReport(false);
        }
        setReportStyle(reportStyle);
        toggleReportTitleModal(true);
    };

    const getSelectedCompIds = () => {
        let compIds = [];
        if (compTab === "all_km_comps") {
            for (const [key, value] of selectedComps) {
                if (value) {
                    compIds.push(key);
                }
            }
        } else {
            for (const [key, value] of brokerComps) {
                if (value) {
                    compIds.push(key);
                }
            }
        }
        compIds = compact(compIds);
        compIds = uniq(compIds);
        return compIds;
    };

    const getSelectedCompObjects = () => {
        const selectedCompIds = getSelectedCompIds();
        if (compTab === "broker_comps") {
            return selectedBrokerCompsForMyComps;
        }
        return filter(comps[compTab], (comp) => {
            const dealKey = compTab === "all_km_comps" ? comp.dealkey : comp.dealKey;
            return includes(selectedCompIds, dealKey);
        });
    };

    const handleMarketingFlyerModalOpen = (nonIndustrialPropertyInSelection) => {
        toggleModalAndGetPhotos(getSelectedCompObjects(), nonIndustrialPropertyInSelection);
    };

    const handleReportDropdown = (event) => {
        setReportDropdown(event.currentTarget);
    };

    const handleExportDropdown = (event) => {
        setExportDropdown(event.currentTarget);
    };

    const checkConfidentiality = (key, tab) => {
        let comp, compKey, listComps;
        if (tab === "broker_comps") {
            comp = selectedBrokerCompsForMyComps?.find((comp) => comp.dealKey === key);
        } else if (tab === "comps_group") {
            listComps = comps["comps_group"];
            if (listComps !== null && listComps !== undefined) comp = listComps.find((comp) => comp.dealkey === key);
        } else if (tab === "all_km_comps") {
            compKey = Object.keys(comps.all_km_comps).find((arrayKey) => comps.all_km_comps[arrayKey].dealkey === key);
            comp = comps.all_km_comps[compKey];
        }

        if (comp && getFromAttributeValues(comp, ["confidentialFlg", "confidential_flg"], null)) {
            return true;
        } else {
            return false;
        }
    };

    const confidentialComps = (reportType, tab) => {
        if (reportType === "selected") {
            let selected = null;
            if (tab === "broker_comps") {
                selected = brokerComps;
            } else if (tab === "comps_group") {
                selected = selectedCompsGroup;
            } else if (tab === "all_km_comps") {
                selected = selectedComps;
            }
            if (selected !== null) {
                for (const [k, v] of selected.entries()) {
                    if (v === true && checkConfidentiality(k, tab)) {
                        return true;
                    }
                }
            }
        } else if (reportType === "all") {
            let currentComps;
            if (tab === "comps_group") {
                currentComps = comps.comps_group;
            } else if (tab === "broker_comps") {
                return confidentialFlagForBrokerComps;
            } else if (tab === "all_km_comps") {
                currentComps = comps["all_km_comps"];
            }

            for (let comp of currentComps) {
                //get from attribute values
                if (checkConfidentiality(comp.dealKey, tab)) {
                    return true;
                }
            }
        }

        return false;
    };

    const confidentialExportModal = (currentReportType) => {
        setConfidentialCompModalOpen(true);
        setReportType(currentReportType);
    };

    const handleConfirmConfidential = () => {
        setConfidentialCompModalOpen(false);
        handleDataExport(reportType, compTab);
    };

    const handleRejectConfidential = () => {
        setConfidentialCompModalOpen(false);
    };

    const handleClose = () => {
        setCloseDealDialogOpen(false);
    };

    const handleExport = (reportType) => {
        setExportDropdown(null);
        if (confidentialComps(reportType, compTab)) {
            confidentialExportModal(reportType);
        } else {
            handleDataExport(reportType, compTab);
        }
    };

    const compz = comps[compTab] ? comps[compTab] : [];
    let disableDeleteFromGroup = true;

    //sets disableDeleteFromGroup to false for Delete from Group button if no comps are selected
    let list = [];
    for (let [key, value] of selectedCompsGroup) {
        if (value && !list.includes(key)) {
            list.push(key);
        }
    }

    if (list.length !== 0) {
        disableDeleteFromGroup = false;
    }

    let selectedList = getSelectedCompIds();
    let nonIndustrialPropertyInSelection = false;
    if (selectedList.length === 1) {
        const currentComps = compTab === "broker_comps" ? selectedBrokerCompsForMyComps : comps[compTab];
        if (Array.isArray(currentComps)) {
            currentComps.forEach((comp) => {
                if (comp.dealKey === selectedList[0] && comp.propertyType !== "Industrial") {
                    nonIndustrialPropertyInSelection = true;
                }
            });
        }
    }

    if (compTab === "all_km_comps" && loadingSearch === true && Object.keys(compz).length !== 0) {
        toggleLoadingSearch(false);
    }

    const handleSearchRunStatus = () => {
        setSelectAll(true);
    };

    const isBrokerOnDeal = (deal) => {
        const brokerName = userProfile.firstName + " " + userProfile.lastName;
        if (
            (deal.listing_agent_users && includes(deal.listing_agent_users.split(","), user)) ||
            (deal.broker_users && includes(deal.broker_users.split(","), user)) ||
            (deal.audit_created_by && deal.audit_created_by === user) ||
            deal.procuring_broker === brokerName ||
            deal.listing_broker === brokerName ||
            (deal.brokers &&
                includes(
                    deal.brokers.split(",").map((broker) => broker.trim()),
                    brokerName
                ))
        ) {
            return true;
        } else {
            return false;
        }
    };

    useEffect(() => {
        if (selectedBrokerCompsForMyComps?.length === 0) {
            setClientSideSortModel([]);
            if (showSelectedItemsOnly) {
                toggleShowSelectedItemsOnly(false);
            }
        }
    }, [selectedBrokerCompsForMyComps?.length, showSelectedItemsOnly, toggleShowSelectedItemsOnly]);

    const disclaimerText = `© 2019 - ${new Date().getFullYear()} Kidder Mathews Inc and its subsidiaries and/or assigns. The information supplied herein is from sources we deem reliable. It is provided without any representation, warranty, or guarantee, expressed or implied as to its accuracy. Prospective Buyer or Tenant should conduct an independent investigation and verification of all matters deemed to be material, including, but not limited to, statements of income and expenses. Consult your attorney, accountant, or other professional advisor. All information is proprietary to Kidder Mathews and intended for the sole purpose of providing consultancy services to clients and should not be reproduced, distributed or used for any other purpose nor divulged to third party data collection agencies as outlined by corporate policy.`;

    const filterColumns = [
        { field: "listingName", label: "Deal Name", type: "plaintext" },
        { field: "addressLine", label: "Address Line", type: "plaintext" },
        { field: "city", label: "City", type: "plaintext" },
        { field: "state", label: "State", type: "plaintext" },
        { field: "zipCode", label: "ZipCode", type: "plaintext" },
        { field: "brokers", label: "Broker", type: "plaintext" },
        { field: "transactionDate", label: "Date Signed", type: "date" },
        { field: "sortableRatePrice", label: "Rate/Price", type: "currency" },
        { field: "squareFeet", label: "Square Feet", type: "numberRange" },
    ];

    return (
        <div>
            <Collapse in={compTab === "all_km_comps"} unmountOnExit style={{ marginLeft: -20, marginRight: -20 }}>
                <CompFilters
                    updateFilter={updateFilter}
                    searchSubmit={handleSearchCompsSubmit}
                    propertySearchFilters={propertySearchFilters}
                    handleSelectAllPropertyType={handleSelectAllPropertyType}
                    clearFilters={clearFilters}
                    searchCriteria={searchCriteria}
                    handleStatusRadioClick={handleStatusRadioClick}
                    handleSizeRadioClick={handleSizeRadioClick}
                    handleDealTypeRadioClick={handleDealTypeRadioClick}
                    errors={errors}
                    togglePropertyTypeExpansionPanel={togglePropertyTypeExpansionPanel}
                    propertyTypeExpansionPanels={propertyTypeExpansionPanels}
                    toggleMarketFilterExpansionPanel={toggleMarketFilterExpansionPanel}
                    marketFilterExpansionPanels={marketFilterExpansionPanels}
                    handleSelectMarket={handleSelectMarket}
                    handleSelectSubmarket={handleSelectSubmarket}
                    handleSelectMicromarket={handleSelectMicromarket}
                    handleSearchRunStatus={handleSearchRunStatus}
                    handleSearchCleared={handleSearchCleared}
                    loadedSearchCrumbs={loadedSearchCrumbs}
                    handleDeleteCrumb={handleDeleteCrumb}
                    role={role}
                />
            </Collapse>
            <StyledPageDiv>
                <div style={{ padding: "8px", boxSizing: "border-box" }}>
                    <h2 className="page-title">Comps</h2>
                    <div className="page-subtitle">
                        {filterQuery > "" && compTab === "broker_comps" && "(Filtered)"}
                        {compTab === "all_km_comps" &&
                            searchResponse &&
                            searchResponse.results &&
                            `Showing ${searchResponse.results.length} ${
                                searchResponse.results.length === 1
                                    ? "comp"
                                    : `comps (${searchResponse.totalResultCount} TOTAL)`
                            }`}
                        {compTab === "comps_group" &&
                            compCurrentGroup &&
                            `You have ${compCurrentGroup.length} ${
                                compCurrentGroup.length === 1
                                    ? "comp in your current list"
                                    : `comps in your current list`
                            }`}
                    </div>
                </div>
                <div style={{ padding: "8px", boxSizing: "border-box" }}>
                    {compTab === "broker_comps" && (
                        <React.Fragment>
                            <KMSwitch
                                checked={showSelectedItemsOnly}
                                disabled={selectedBrokerCompsForMyComps?.length === 0}
                                onChange={(e) => toggleShowSelectedItemsOnly(e.target.checked)}
                                label="Show Selected Items Only"
                            ></KMSwitch>
                            <Button
                                disabled={selectedBrokerCompsForMyComps?.length === 0}
                                variant="contained"
                                color="primary"
                                onClick={(e) => resetSelectedBrokerComps()}
                            >
                                Uncheck All
                            </Button>
                        </React.Fragment>
                    )}
                    {compTab === "all_km_comps" || compTab === "broker_comps" ? (
                        <Button
                            disabled={false}
                            variant="contained"
                            color="primary"
                            onClick={(e) => addSelectedToGroup(compTab)}
                        >
                            Add to List
                        </Button>
                    ) : compTab === "comps_group" ? (
                        <React.Fragment>
                            <Button
                                disabled={disableDeleteFromGroup}
                                variant="contained"
                                color="primary"
                                onClick={(e) => deleteSelectedFromGroup()}
                            >
                                Delete From List
                            </Button>
                            <Button
                                disabled={disableDeleteFromGroup}
                                variant="contained"
                                color="primary"
                                onClick={(e) => clearCurrentGroup()}
                            >
                                Clear List
                            </Button>
                        </React.Fragment>
                    ) : (
                        ""
                    )}
                    {(compTab === "all_km_comps" || compTab === "comps_group" || compTab === "broker_comps") &&
                        (get(dataExport, "exportInProgress", false) === true ? (
                            <Button disabled={true} variant="outlined" color="primary">
                                <ExportIcon /> In Progress
                            </Button>
                        ) : (
                            <Tooltip
                                title={disclaimerText}
                                placement="left-start"
                                slotProps={{
                                    popper: {
                                        modifiers: [
                                            {
                                                name: "offset",
                                                options: {
                                                    offset: [0, 75],
                                                },
                                            },
                                        ],
                                    },
                                }}
                            >
                                <div
                                    style={{
                                        display: "inline-block",
                                        verticalAlign: "middle",
                                        marginLeft: "4px",
                                        position: "relative",
                                    }}
                                >
                                    <Button
                                        id="Export_Comp"
                                        aria-haspopup="true"
                                        onClick={(e) => handleExportDropdown(e)}
                                        endIcon={<ArrowDropDownIcon />}
                                        color="primary"
                                        variant="contained"
                                        disabled={Object.keys(compz).length === 0}
                                    >
                                        Export
                                    </Button>
                                    {exportDropdown && (
                                        <React.Fragment>
                                            <Menu
                                                id="Export_Comp_Menu"
                                                anchorEl={exportDropdown}
                                                open={Boolean(exportDropdown)}
                                                onClose={() => {
                                                    setExportDropdown(null);
                                                }}
                                                anchorOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "right",
                                                }}
                                                transformOrigin={{
                                                    vertical: "top",
                                                    horizontal: "right",
                                                }}
                                            >
                                                <MenuItem
                                                    onClick={() => {
                                                        handleExport("selected");
                                                    }}
                                                >
                                                    Selected Comps Only
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() => {
                                                        handleExport("all");
                                                    }}
                                                >
                                                    {compTab === "comps_group" ? "Entire Group" : "Entire Data Set"}
                                                </MenuItem>
                                            </Menu>
                                        </React.Fragment>
                                    )}
                                </div>
                            </Tooltip>
                        ))}
                    {role !== "anonymous" &&
                        (compTab === "all_km_comps" || compTab === "comps_group" || compTab === "broker_comps") &&
                        (elementsSaving.generateCompReport ? (
                            <Button disabled={true} variant="contained" color="secondary">
                                <StyledLoadingProgress size={15} />
                                Generating
                            </Button>
                        ) : (
                            <Tooltip
                                title={disclaimerText}
                                placement="left-start"
                                slotProps={{
                                    popper: {
                                        modifiers: [
                                            {
                                                name: "offset",
                                                options: {
                                                    offset: [0, 75],
                                                },
                                            },
                                        ],
                                    },
                                }}
                            >
                                <div
                                    style={{
                                        display: "inline-block",
                                        verticalAlign: "middle",
                                        marginLeft: "4px",
                                        position: "relative",
                                    }}
                                >
                                    <Button
                                        id="Generate_Comp_Report"
                                        aria-haspopup="true"
                                        onClick={(e) => handleReportDropdown(e)}
                                        endIcon={<ArrowDropDownIcon />}
                                        color="primary"
                                        variant="contained"
                                        disabled={Object.keys(compz).length === 0}
                                    >
                                        Generate Report
                                    </Button>
                                    {reportDropdown && (
                                        <React.Fragment>
                                            <Menu
                                                id="Generate_Report"
                                                anchorEl={reportDropdown}
                                                open={Boolean(reportDropdown)}
                                                onClose={() => {
                                                    setReportDropdown(null);
                                                }}
                                                anchorOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "right",
                                                }}
                                                transformOrigin={{
                                                    vertical: "top",
                                                    horizontal: "right",
                                                }}
                                            >
                                                <MenuItem onClick={() => handleClickOpen("Standard")}>
                                                    Standard
                                                </MenuItem>
                                                <MenuItem onClick={() => handleClickOpen("Metro")}>
                                                    Metro Lease
                                                </MenuItem>
                                                <MenuItem onClick={() => handleClickOpen("MapOverview")}>
                                                    Map Overview
                                                </MenuItem>
                                                <MenuItem onClick={() => handleClickOpen("HalfMap-HalfProperty")}>
                                                    Half Map / Half Property List
                                                </MenuItem>
                                                <MenuItem onClick={() => handleClickOpen("IndividualDetail")}>
                                                    Individual Comp Page Detail
                                                </MenuItem>
                                                <MenuItem onClick={() => handleClickOpen("Reference")}>
                                                    Property Reference
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() => {
                                                        setReportDropdown(null);
                                                        handleMarketingFlyerModalOpen(nonIndustrialPropertyInSelection);
                                                    }}
                                                >
                                                    Marketing Flyer
                                                </MenuItem>
                                            </Menu>
                                        </React.Fragment>
                                    )}
                                </div>
                            </Tooltip>
                        ))}
                    {role !== "anonymous" && compTab !== "comps_group" && (
                        <OutsideCompModal {...props} searchFunction={searchProperty} />
                    )}
                    {role === "appraiser" && (
                        <CreateCompModal {...props} searchFunction={searchProperty} createComp={addAppraisalComp} />
                    )}
                </div>
            </StyledPageDiv>
            <StyledCompTable>
                <div style={{ padding: "8px", flexGrow: "1", maxWidth: "100%", flexBasis: 0, boxSizing: "border-box" }}>
                    <div className="simPaper">
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                boxSizing: "border-box",
                            }}
                        >
                            <div style={{ boxSizing: "border-box" }}>
                                <Tabs value={compTab} onChange={(event, value) => switchTab(event, value, user)}>
                                    {includes(
                                        [
                                            "broker",
                                            "evp",
                                            "portlandBrokerAdmin",
                                            "arizonaBrokerAdmin",
                                            "general",
                                            "officeManager",
                                            "appraiser",
                                            "research",
                                            "researchAdmin",
                                            "propertyManagement",
                                            "transition",
                                            "accounting",
                                            "dataEntry",
                                            "dataAdmin",
                                            "debtEquity",
                                        ],
                                        role
                                    ) && <StyledTab value="broker_comps" label="My Comps" />}
                                    <Tab value="all_km_comps" label="All Comps" />
                                    <Tab
                                        value="comps_group"
                                        label={`Current List (${compCurrentGroup ? compCurrentGroup.length : "0"})`}
                                    />
                                </Tabs>
                            </div>
                            {compTab === "broker_comps" && (
                                <div style={{ display: showSelectedItemsOnly ? "none" : "block" }}>
                                    <CustomDataGridFilterToolbar
                                        fields={filterColumns}
                                        setFilter={setCompsFilter}
                                        setPage={setCompsPage}
                                        onSubmit={() => getComps(compTab)}
                                    />
                                </div>
                            )}
                            {/* Map icons */}
                            {(compTab === "all_km_comps" || compTab === "comps_group") && (
                                <div>
                                    <div style={{ boxSizing: "border-box" }}>
                                        {mapDisplay ? (
                                            <div>
                                                <Button style={{ minWidth: "40px" }} onClick={() => toggleMap(false)}>
                                                    <List />
                                                </Button>
                                            </div>
                                        ) : (
                                            <div>
                                                <Button style={{ minWidth: "40px" }} onClick={() => toggleMap(true)}>
                                                    <Map />
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>

                        {(compTab === "all_km_comps" || compTab === "comps_group") && mapDisplay ? (
                            <CompsWithMap
                                {...props}
                                places={compz}
                                selectAll={selectAll}
                                selectAllGroup={selectAllGroup}
                                searchRun={searchRun}
                                searchCleared={compTab === "comps_group" ? false : searchCleared}
                                handleSelectAll={toggleSelectAll}
                                handleSelectAllGroup={toggleSelectAllGroup}
                                handleSearchCleared={handleSearchCleared}
                                handleSearchSubmit={handleSearchSubmit}
                                mapCrumbCleared={mapCrumbCleared}
                                searchPolygon={searchPolygon}
                                updateSearchPolygon={updateSearchPolygon}
                                searchResponse={searchResponse}
                                isBrokerOnDeal={isBrokerOnDeal}
                            />
                        ) : compTab === "broker_comps" ? (
                            <MyCompsDataGrid
                                {...props}
                                isBrokerOnDeal={isBrokerOnDeal}
                                clientSideSortModel={clientSideSortModel}
                                setClientSideSortModel={setClientSideSortModel}
                            />
                        ) : (
                            <CompsWithoutMap
                                {...props}
                                searchCleared={compTab === "comps_group" ? false : searchCleared}
                                selectAll={selectAll}
                                selectAllGroup={selectAllGroup}
                                selectAllBrokerComps={selectAllBrokerComps}
                                handleSelectAll={toggleSelectAll}
                                handleSelectAllGroup={toggleSelectAllGroup}
                                handleSelectAllBrokerComps={toggleSelectAllBrokerComps}
                                filterQuery={filterQuery}
                                isBrokerOnDeal={isBrokerOnDeal}
                            />
                        )}
                    </div>
                </div>
            </StyledCompTable>
            <Dialog
                open={closeDealDialogOpen}
                onClose={handleClose}
                aria-labelledby="close-deal"
                aria-describedby="close-deal-dialog"
            >
                <DialogTitle id="close-deal">{"Are you sure?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Closing this deal will start the invoice process for this transaction and move the comp to a
                        closed status.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" variant="outlined">
                        Disagree
                    </Button>
                    <Button onClick={handleClose} color="secondary" autoFocus variant="contained">
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
            <ReportTitleModal
                {...props}
                reportType="Comp"
                selectedComps={selectedList}
                nonIndustrialPropertyInSelection={nonIndustrialPropertyInSelection}
                tab={compTab}
                metroReport={metroReport}
                reportStyle={reportStyle}
                hasConfidentialComps={confidentialComps("selected", compTab)}
            />
            <SavedSearchesModal
                {...props}
                handleGridSort={handleSort}
                tab={compTab}
                searchType="comps"
                showModal={viewSavedModal}
            />
            <NameSearchModal {...props} searchType="comps" tab={compTab} showModal={nameSaveModal} />
            <ConfidentialCompModal
                {...props}
                confidentialCompModalOpen={confidentialCompModalOpen}
                handleConfirm={handleConfirmConfidential}
                handleReject={handleRejectConfidential}
            />
            <GenerateImageEditorModalContainer
                reportName={"Marketing Flyer Comp"}
                nonIndustrialPropertyInSelection={nonIndustrialPropertyInSelection}
                editorDimensions={{ width: "1224px", height: "440px" }}
                setDealParty={setDealParty}
                timeOnMarketInput={timeOnMarketInput}
                toggleModal={toggleModal}
                elementsSaving={elementsSaving}
                modalContent={modalContent}
                handleCloseModal={handleCloseModal}
                setMarketingFlyerPhoto={setMarketingFlyerPhoto}
                resetPhoto={resetPhoto}
                selectedCompId={head(getSelectedCompIds())}
                generateCompReport={generateCompReport}
                compTab={compTab}
            />
        </div>
    );
};

export default ReviewComps;
